// import {
//   Backdrop,
//   Box,
//   CircularProgress,
//   Drawer,
//   Menu,
//   MenuItem,
// } from "@mui/material";
// import Pusher from "pusher-js";
// import MobileNavbar from "../mobileNavbar";
// import { useEffect, useState } from "react";
// import noImageAvailable from "../../../images/No_Image_Available.jpg";
// import {
//   FCM_TOKEN,
//   getAuthMobile,
//   getGustAuthMobile,
//   sendNotificationFirebaseRes,
//   setMobileBackColor,
//   setMobileButttonBackColor,
//   setMobileCardBorderColor,
//   setMobileCardColor,
//   setMobileTextColor,
// } from "../../../utility";
// import axios from "axios";
// import { ScrollMenu } from "react-horizontal-scrolling-menu";
// import "react-horizontal-scrolling-menu/dist/styles.css";
// import { useNavigate, useSearchParams } from "react-router-dom";
// import { useQuery } from "react-query";
// import CheckOutlinedIcon from "@mui/icons-material/CheckOutlined";
// import DarkModeIcon from "@mui/icons-material/DarkMode";
// import LightModeIcon from "@mui/icons-material/LightMode";
// import Snapchat from "../../../images/snapchat.svg";
// import Facebook from "../../../images/facebook-icon.svg";
// import Twitter from "../../../images/twitter.svg";
// import Instagram from "../../../images/instigram.svg";
// import Global from "../../../images/global.svg";
// import { CloseOutlined, TranslateOutlined } from "@mui/icons-material";
// import { t } from "i18next";
// import Loading from "../../../common/loading";
// import { Badge } from "react-bootstrap";

// import { ToastContainer, toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
// import addNotification from "react-push-notification";

// const Top = ({
//   qrCode,
//   qrName,
//   updateTreeData,
//   handleLanguage,
//   currentId,
//   parentId,
//   mianSectionsData,
//   detailsData,
//   handleParentSection,
//   handleParent,
//   backToMain,
//   width,
//   order_ability,
//   lablesData,
//   label_name,
//   itemsRefetch
// }) => {
//   const mode = localStorage.getItem("theme");
//   const language = localStorage.getItem("lang");
//   const [isScrolled, setIsScrolled] = useState(false);

//   const [state, setState] = useState({ right: false });
//   const [params, setParams] = useSearchParams();
//   const [loading, setLoading] = useState(false);
//   const navigate = useNavigate();

//   const [anchorlang, setAnchorlang] = useState(null);
//   const openLang = Boolean(anchorlang);
//   const [loadingTree, setLoadingTree] = useState(false);
//   const handleClickLang = (event) => {
//     setAnchorlang(event.currentTarget);
//   };
//   const handleCloseLang = () => {
//     setAnchorlang(null);
//   };

//   useEffect(() => {
//     const handleScroll = () => {
//       if (window.pageYOffset > 0) {
//         setIsScrolled(true);
//       } else {
//         setIsScrolled(false);
//       }
//     };
//     window.addEventListener("scroll", handleScroll);
//     return () => {
//       window.removeEventListener("scroll", handleScroll);
//     };
//   }, []);

//   useEffect(() => {
//     const pusher = new Pusher("ae14bac927c237af424c", {
//       cluster: "mt1",
//       auth: getGustAuthMobile(),
//     });

//     const channel = pusher.subscribe(
//       `customer_notifications.${localStorage.getItem("gustToken")}`
//     );


//     channel.bind("App\\Events\\NotificationRespond", (data) => {
//       addNotification({
//         title: data.title,
//         message: data.message,
//         duration: 8000,
//         icon: detailsData?.logo || noImageAvailable,
//         native: true,
//       });
//     });

//     return () => {
//       pusher.unsubscribe("customer_notifications");
//       pusher.disconnect();
//     };
//   }, []);

//   const {
//     data: languagesData,
//     isLoading: languagesIsLoading,
//     isError: LanguagesIsError,
//     error: languagesError,
//   } = useQuery("languages", () => {
//     const timeZone = localStorage.getItem("timezone")
//       ? localStorage.getItem("timezone")
//       : "";

//     try {
//       return axios.get(
//         `${process.env.REACT_APP_API}/menus/${qrCode}/public-languages`,
//         {
//           headers: {
//             localization: localStorage.getItem("lang"),
//             timeZone: timeZone.replace(/["]+/g, ""),
//           },
//         }
//       );
//     } catch (error) { }
//   });

//   const handleFeedBack = () => {
//     navigate(
//       `/${qrName}/${qrCode}/feedback?section=${currentId}&t=${params.get("t")}`
//     );
//   };

//   const handlePrivacyPolicy = () => {
//     navigate(
//       `/${qrName}/${qrCode}/privacy-policy`
//     );
//   };

//   const handleTermsAndConditions = () => {
//     navigate(
//       `/${qrName}/${qrCode}/terms-and-conditions`
//     );
//   };


//   const handleHome = () => {
//     navigate(`/${qrName}/${qrCode}/menus?lang=${language}`);
//   };

//   const handleProfile = () => {
//     navigate(`/${qrName}/${qrCode}/profile?lang=${language}`);
//   };

//   const handleLogout = async () => {
//     await localStorage.setItem("mobileLoginToken", "");
//     navigate(`/${qrName}/${qrCode}/menus?lang=${language}`);
//   };

//   const handleFavorites = () => {
//     navigate(
//       `/${qrName}/${qrCode}/favorites?section=${currentId}&t=${params.get("t")}`
//     );
//   };
//   const handleOrders = () => {
//     navigate(
//       `/${qrName}/${qrCode}/orders?section=${currentId}&t=${params.get("t")}`
//     );
//   };

//   const onImageError = (e) => {
//     e.target.src = noImageAvailable;
//   };

//   const hanldeMode = () => {
//     if (localStorage.getItem("theme") === "dark") {
//       localStorage.setItem("theme", "light");
//       params.set("theme", "light");
//       setParams(params);
//     } else {
//       localStorage.setItem("theme", "dark");
//       params.set("theme", "dark");
//       setParams(params);
//     }
//   };

//   const handleSocialPage = (page) => {
//     window.open(page, "_blank");
//   };

//   const handleLanguagedata = async (langCode) => {
//     setLoadingTree(true);
//     try {
//       const timeZone = localStorage.getItem("timezone") || "";
//       const promise = await axios.get(
//         `${process.env.REACT_APP_API}/menus/${qrCode}/public-tree`,
//         {
//           headers: {
//             localization: langCode,
//             timeZone: timeZone.replace(/["]+/g, ""),
//           },
//         }
//       );
//       await localStorage.setItem(
//         "tree_data",
//         JSON.stringify(promise?.data?.data ? promise?.data?.data : [])
//       );
//       await updateTreeData(promise?.data?.data || []);

//       handleLanguage(langCode);
//       itemsRefetch();
//     } catch (error) {
//       // Handle error
//     } finally {
//       setLoadingTree(false); // Hide progress dialog
//     }
//   };

//   const handleSendNotification = async (title, body) => {
//     try {
//       const sendNotificationRes = await axios.post(
//         `${process.env.REACT_APP_API}/general-notification`,
//         {
//           venue_id: detailsData?.venue_id,
//           title: title || "",
//           message: body || "",
//           table: params.get("t") || "",
//         }
//       );



//       const sendNotificationFirebase = await sendNotificationFirebaseRes(detailsData, title || "", body || "", "notifications");
//       if (sendNotificationRes?.data?.success && sendNotificationFirebase?.data?.success) {
//         setLoading(false);
//         toast.success(
//           <div className="alignByLang">
//             {t("Your notification sent successfully")}
//           </div>
//         );
//       } else {
//         setLoading(false);

//         toast.error(
//           <div className="alignByLang">
//             {t("Error while sending the notification.")}
//           </div>
//         );
//       }
//     } catch (error) {
//       setLoading(false);

//       toast.error(
//         <div className="alignByLang">
//           {t("Error while sending the notification.") + " " + error.message}
//         </div>
//       );
//     }
//   };

//   const list = (anchor) => (
//     <Box
//       sx={{ width: anchor === "top" || anchor === "bottom" ? "auto" : 350 }}
//       role="presentation"
//       onKeyDown={toggleDrawer(anchor, false)}
//     >
//       <div
//         className={`mobile-side-bar min-vh-100`}
//         style={{
//           color: setMobileTextColor(),
//           backgroundColor: setMobileCardColor(),
//         }}
//       >
//         <div className="d-flex justify-content-between mobile-side-bar-top-settings p-4 sub-font">
//           <img
//             src={detailsData?.logo || noImageAvailable}
//             alt="logo"
//             style={{ border: `4px solid ${setMobileCardColor()} ` }}
//             className="mobile-side-bar-logo"
//             onError={onImageError}
//           />

//           <div className="d-flex justify-content-between">
//             <div>
//               {" "}
//               <span
//                 className="mx-2 pt-0 cursor"
//                 onClick={toggleDrawer(anchor, false)}
//               >
//                 <CloseOutlined style={{ color: setMobileTextColor() }} />
//               </span>
//               <span className="mx-2 pt-0 cursor" onClick={handleClickLang}>
//                 <TranslateOutlined style={{ color: setMobileTextColor() }} />
//               </span>
//               <Menu
//                 id="long-menu"
//                 MenuListProps={{
//                   "aria-labelledby": "long-button",
//                 }}
//                 anchorEl={anchorlang}
//                 open={openLang}
//                 onClose={handleCloseLang}
//                 onClick={handleCloseLang}
//                 PaperProps={{
//                   style: {
//                     maxHeight: 48 * 4.5,
//                     width: "25ch",
//                     backgroundColor: setMobileBackColor(),
//                   },
//                 }}
//               >
//                 {languagesData?.data?.data?.languages?.map((lang) => (
//                   <MenuItem
//                     key={lang.code}
//                     onClick={() => handleLanguagedata(lang.code)}
//                   >
//                     <li
//                       className="d-flex justify-content-between align-items-center p-1 sub-font"
//                       style={{
//                         color:
//                           language === lang.code
//                             ? setMobileButttonBackColor()
//                             : setMobileTextColor(),
//                       }}
//                     >
//                       <span style={{ maxWidth: "80%" }}>
//                         {" "}
//                         {` ${lang.label} ( ${lang.label} )  `}
//                       </span>
//                       <span
//                         style={{ maxWidth: "10%" }}
//                         className={`${language === lang.code ? "d-block" : "d-none"
//                           }`}
//                       >
//                         <CheckOutlinedIcon />
//                       </span>
//                     </li>
//                   </MenuItem>
//                 ))}
//               </Menu>
//             </div>
//             <div>
//               {localStorage.getItem("theme") !== "costomize" && (
//                 <span className="ms-2 pt-0 cursor" onClick={hanldeMode}>
//                   {mode === "dark" ? (
//                     <DarkModeIcon className="mode-icon-dark" />
//                   ) : (
//                     <LightModeIcon className="mode-icon-light" />
//                   )}
//                 </span>
//               )}
//             </div>
//             <div>
//               {localStorage.getItem("theme") !== "costomize" && (
//                 <span className="ms-2 pt-0 cursor" onClick={hanldeMode}>
//                   {mode === "dark" ? (
//                     <DarkModeIcon className="mode-icon-dark" />
//                   ) : (
//                     <LightModeIcon className="mode-icon-light" />
//                   )}
//                 </span>
//               )}
//             </div>
//           </div>
//         </div>
//         {loadingTree && <Loading backColor={setMobileBackColor()} />}

//         <div className="p-24">
//           <div
//             className="rounded-4 m-top-12 pt-3 pb-3 px-3 alignByLang"
//             style={{
//               backgroundColor: setMobileBackColor(),
//               borderColor: setMobileCardBorderColor(),
//               borderWidth: 1,
//               borderStyle: "solid",
//             }}
//           >
//             {JSON.parse(params.get("t")) && (
//               <>
//                 <Badge
//                   style={{
//                     borderRadius: "8px",
//                   }}
//                   className={`outofinstock-badge-dish-style  font-size-14 sub-font m-1`}
//                 >
//                   {t("Call Waiter")}
//                 </Badge>

//                 {detailsData?.notification_buttons_settings
//                   ?.notification_1_active && (
//                     <Badge
//                       onClick={() =>
//                         handleSendNotification(
//                           detailsData?.notification_buttons_settings
//                             ?.notification_1_title,
//                           detailsData?.notification_buttons_settings
//                             ?.notification_1_body
//                         )
//                       }
//                       style={{
//                         borderRadius: "8px",
//                       }}
//                       className={`outofinstock-badge-dish-style  font-size-14 sub-font m-1`}
//                     >
//                       {t(
//                         detailsData?.notification_buttons_settings
//                           ?.notification_1_button
//                       ) || ""}
//                     </Badge>
//                   )}

//                 {detailsData?.notification_buttons_settings
//                   ?.notification_2_active && (
//                     <Badge
//                       onClick={() =>
//                         handleSendNotification(
//                           detailsData?.notification_buttons_settings
//                             ?.notification_2_title,
//                           detailsData?.notification_buttons_settings
//                             ?.notification_2_body
//                         )
//                       }
//                       style={{
//                         borderRadius: "8px",
//                       }}
//                       className={`outofinstock-badge-dish-style  font-size-14 sub-font m-1`}
//                     >
//                       {t(
//                         detailsData?.notification_buttons_settings
//                           ?.notification_2_button
//                       ) || ""}
//                     </Badge>
//                   )}
//               </>
//             )}
//             <p className="m-top-12 cursor head-font" onClick={handleHome}>
//               {t("Home")}
//             </p>

//             {localStorage.getItem("mobileLoginToken") &&
//               localStorage.getItem("mobileLoginToken")?.length > 0 ? (
//               <p className="m-top-12 cursor head-font" onClick={handleProfile}>
//                 {t("My Profile")}
//               </p>
//             ) : (
//               ""
//             )}

//             <p className="m-top-12 cursor head-font" onClick={handleFavorites}>
//               {t("Favorites")}
//             </p>

//             {order_ability && localStorage.getItem("mobileLoginToken") ? (
//               <p onClick={handleOrders} className="cursor head-font">
//                 {t("My orders")}
//               </p>
//             ) : (
//               ""
//             )}

//             <p onClick={handleFeedBack} className="cursor head-font">
//               {t("Your opinion Matters!")}
//             </p>

//             <p onClick={handlePrivacyPolicy} className="cursor head-font">
//               {t("Privacy Policy")}
//             </p>

//             <p onClick={handleTermsAndConditions} className="cursor head-font">
//               {t("Terms and Conditions")}
//             </p>

//             {localStorage.getItem("mobileLoginToken") &&
//               localStorage.getItem("mobileLoginToken")?.length > 0 ? (
//               <p onClick={handleLogout} className="cursor head-font">
//                 {t("Logout")}
//               </p>
//             ) : (
//               ""
//             )}
//           </div>
//         </div>
//         <div style={{ borderBottom: "1px solid #aaa" }}></div>
//       </div>
//       <ul className="position-absolute mb-4 bottom-0 start-0 w-100 d-flex justify-content-center list-unstyled">
//         {detailsData?.facebook && (
//           <li className="mx-2">
//             <img
//               onClick={() => handleSocialPage(detailsData?.facebook)}
//               src={Facebook}
//               alt="Facebook icon"
//               className="cursor"
//             />
//           </li>
//         )}
//         {detailsData?.instagram && (
//           <li className="mx-2">
//             <img
//               onClick={() => handleSocialPage(detailsData?.instagram)}
//               src={Instagram}
//               alt="Instagram icon"
//               className="cursor"
//             />
//           </li>
//         )}
//         {detailsData?.twitter && (
//           <li className="mx-2">
//             <img
//               onClick={() => handleSocialPage(detailsData?.twitter)}
//               src={Twitter}
//               alt="X icon"
//               className="cursor"
//             />
//           </li>
//         )}
//         {detailsData?.snapchat && (
//           <li className="mx-2">
//             <img
//               onClick={() => handleSocialPage(detailsData?.snapchat)}
//               src={Snapchat}
//               alt="Snapchat icon"
//               className="cursor"
//             />
//           </li>
//         )}
//         {detailsData?.website && (
//           <li className="mx-2">
//             <img
//               onClick={() => handleSocialPage(detailsData?.website)}
//               src={Global}
//               alt="global icon"
//               className="cursor"
//             />
//           </li>
//         )}
//       </ul>
//     </Box>
//   );

//   const toggleDrawer = (anchor, open) => (event) => {
//     if (
//       event.type === "keydown" &&
//       (event.key === "Tab" || event.key === "Shift")
//     ) {
//       return;
//     }

//     setState({ ...state, [anchor]: open });
//   };

//   const openBar = () => {
//     setState({ right: true });
//   };

//   return (
//     !languagesIsLoading &&
//     mianSectionsData && (
//       <div
//         className={`position-relative`}
//         style={{ backgroundColor: setMobileBackColor() }}
//       >
//         <MobileNavbar
//           toggleDrawer={toggleDrawer}
//           openBar={openBar}
//           logo={detailsData?.logo}
//           cover={detailsData?.cover}
//           desc={detailsData?.description}
//           parentId={parentId}
//           venueName={detailsData?.venu_name}
//           handleParent={handleParent}
//           backToMain={backToMain}
//           width={width}
//           label_name={label_name}
//         />
//         <ToastContainer />
//         <Backdrop
//           open={loading}
//           sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
//         >
//           <CircularProgress color="inherit" />
//         </Backdrop>

//         {!window.location.pathname.includes("/labels") && (
//           <div>
//             <div style={{ margin: "auto" }}>
//               {mianSectionsData.sections && (
//                 <div
//                   className={`${isScrolled
//                     ? `top-fixed-sections-scroll`
//                     : `top-fixed-sections`
//                     }   w-100 sub-font alignByLang ${localStorage.getItem("mode") === "dark" ? "dark" : "light"
//                     }`}
//                   style={{
//                     margin: "auto",
//                     backgroundColor: setMobileBackColor(),
//                     width: width,
//                   }}
//                 >
//                   <ScrollMenu
//                     variant="quilted"
//                     cols={mianSectionsData.sections.length}
//                     className="mt-2 mb-2 alignByLang"
//                   >
//                     {mianSectionsData.sections.map((section) => {
//                       return (
//                         <label
//                           key={section.id}
//                           onClick={() => handleParentSection(section)}
//                           className="sections-list cursor p-2 mb-3 sub-font"
//                           style={{
//                             color:
//                               currentId == section.id
//                                 ? setMobileButttonBackColor()
//                                 : setMobileTextColor(),
//                             borderColor:
//                               currentId == section.id
//                                 ? setMobileButttonBackColor()
//                                 : setMobileTextColor(),
//                           }}
//                         >
//                           {section.name}
//                         </label>
//                       );
//                     })}
//                   </ScrollMenu>
//                 </div>
//               )}
//             </div>
//           </div>
//         )}

//         <Drawer
//           anchor={
//             localStorage.getItem("lang") === "ar" ||
//               localStorage.getItem("lang") === "fa"
//               ? "right"
//               : "left"
//           }
//           open={state["right"]}
//           onClose={toggleDrawer("right", false)}
//         >
//           {list("right")}
//         </Drawer>
//       </div>
//     )
//   );
// };

// export default Top;


import {
  Backdrop,
  Box,
  CircularProgress,
  Drawer,
  Menu,
  MenuItem,
} from "@mui/material";
import Pusher from "pusher-js";
import MobileNavbar from "../mobileNavbar";
import React, { useEffect, useRef, useState } from "react";
import noImageAvailable from "../../../images/No_Image_Available.jpg";
import {
  FCM_TOKEN,
  getAuthMobile,
  getGustAuthMobile,
  sendNotificationFirebaseRes,
  setMobileBackColor,
  setMobileButttonBackColor,
  setMobileCardBorderColor,
  setMobileCardColor,
  setMobileTextColor,
} from "../../../utility";
import axios from "axios";
import { ScrollMenu } from "react-horizontal-scrolling-menu";
import "react-horizontal-scrolling-menu/dist/styles.css";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useQuery } from "react-query";
import CheckOutlinedIcon from "@mui/icons-material/CheckOutlined";
import DarkModeIcon from "@mui/icons-material/DarkMode";
import LightModeIcon from "@mui/icons-material/LightMode";
import Snapchat from "../../../images/snapchat.svg";
import Facebook from "../../../images/facebook-icon.svg";
import Twitter from "../../../images/twitter.svg";
import Instagram from "../../../images/instigram.svg";
import Global from "../../../images/global.svg";
import { CloseOutlined, TranslateOutlined } from "@mui/icons-material";
import { t } from "i18next";
import Loading from "../../../common/loading";
import { Badge } from "react-bootstrap";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import addNotification from "react-push-notification";

const Top = ({
  qrCode,
  qrName,
  updateTreeData,
  handleLanguage,
  currentId,
  parentId,
  currentSectionId,
  mianSectionsData,
  detailsData,
  lablesData,
  handleOnClick,
  handleParentSection,
  handleParent,
  backToMain,
  width,
  order_ability,
  label_name,
  itemsRefetch
}) => {
  const mode = localStorage.getItem("theme");
  const language = localStorage.getItem("lang");
  const [isScrolled, setIsScrolled] = useState(false);
  const [loading, setLoading] = useState(false);
  const [state, setState] = useState({ right: false });
  const [params, setParams] = useSearchParams();
  const navigate = useNavigate();
  const sectionRefs = useRef([]);

  const [anchorlang, setAnchorlang] = useState(null);
  const openLang = Boolean(anchorlang);
  const [loadingTree, setLoadingTree] = useState(false);

  // Determine which mode we're in based on available props/data
  const isMainMode = mianSectionsData?.tree?.tree && handleOnClick;
  const isSectionMode = mianSectionsData?.sections?.sections && handleParentSection;

  const handleClickLang = (event) => {
    setAnchorlang(event.currentTarget);
  };

  const handleCloseLang = () => {
    setAnchorlang(null);
  };

  const getDeviceType = () => {
    const userAgent = navigator.userAgent;
    if (/iPhone/i.test(userAgent)) {
      return "iPhone";
    } else if (/Android/i.test(userAgent)) {
      return "Android";
    } else {
      return "Other";
    }
  };

  const handleOnNavClick = (index) => {
    if (handleOnClick) {
      handleOnClick(index);
    }
  };

  // Auto-scroll effect for main mode
  useEffect(() => {
    if (isMainMode && currentSectionId !== undefined) {
      const deviceType = getDeviceType();

      if (sectionRefs.current[currentSectionId]) {
        if (deviceType === "iPhone") {
          sectionRefs.current[currentSectionId].scrollIntoView({
            behavior: "smooth",
            block: "start",
            inline: "nearest",
          });
        } else {
          sectionRefs.current[currentSectionId].scrollIntoView({
            behavior: "smooth",
            block: "start",
            inline: "nearest",
          });
        }
      }
    }
  }, [currentSectionId, sectionRefs, isMainMode]);

  useEffect(() => {
    const handleScroll = () => {
      if (window.pageYOffset > 0) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  useEffect(() => {
    const pusher = new Pusher("ae14bac927c237af424c", {
      cluster: "mt1",
      auth: getGustAuthMobile(),
    });

    const channel = pusher.subscribe(
      `customer_notifications.${localStorage.getItem("gustToken")}`
    );

    channel.bind("App\\Events\\NotificationRespond", (data) => {
      addNotification({
        title: data.title,
        message: data.message,
        duration: 8000,
        icon: detailsData?.logo || noImageAvailable,
        native: true,
      });
    });

    return () => {
      pusher.unsubscribe("customer_notifications");
      pusher.disconnect();
    };
  }, []);

  const {
    data: languagesData,
    isLoading: languagesIsLoading,
    isError: LanguagesIsError,
    error: languagesError,
  } = useQuery("languages", () => {
    const timeZone = localStorage.getItem("timezone")
      ? localStorage.getItem("timezone")
      : "";

    try {
      return axios.get(
        `${process.env.REACT_APP_API}/menus/${qrCode}/public-languages`,
        {
          headers: {
            localization: localStorage.getItem("lang"),
            timeZone: timeZone.replace(/["]+/g, ""),
          },
        }
      );
    } catch (error) { }
  });

  const handleFeedBack = () => {
    navigate(
      `/${qrName}/${qrCode}/feedback?section=${currentId}&t=${params.get("t")}`
    );
  };

  const handlePrivacyPolicy = () => {
    navigate(`/${qrName}/${qrCode}/privacy-policy`);
  };

  const handleTermsAndConditions = () => {
    navigate(`/${qrName}/${qrCode}/terms-and-conditions`);
  };

  const handleHome = () => {
    const baseUrl = `/${qrName}/${qrCode}/menus?lang=${language}`;
    const tableParam = params.get("t");
    navigate(tableParam ? `${baseUrl}&t=${tableParam}` : baseUrl);
  };

  const handleProfile = () => {
    const baseUrl = `/${qrName}/${qrCode}/profile?lang=${language}`;
    const tableParam = params.get("t");
    navigate(tableParam ? `${baseUrl}&t=${tableParam}` : baseUrl);
  };

  const handleLogout = async () => {
    await localStorage.setItem("mobileLoginToken", "");
    const baseUrl = `/${qrName}/${qrCode}/menus?lang=${language}`;
    const tableParam = params.get("t");
    navigate(tableParam ? `${baseUrl}&t=${tableParam}` : baseUrl);
  };

  const handleFavorites = () => {
    navigate(
      `/${qrName}/${qrCode}/favorites?section=${currentId}&t=${params.get("t")}`
    );
  };

  const handleOrders = () => {
    navigate(
      `/${qrName}/${qrCode}/orders?section=${currentId}&t=${params.get(
        "t"
      )}&lang=${language}`
    );
  };

  const handleTransactions = () => {
    navigate(
      `/${qrName}/${qrCode}/transactions?section=${currentId}&t=${params.get(
        "t"
      )}&lang=${language}`
    );
  }

  const onImageError = (e) => {
    e.target.src = noImageAvailable;
  };

  const hanldeMode = () => {
    if (localStorage.getItem("theme") === "dark") {
      localStorage.setItem("theme", "light");
      params.set("theme", "light");
      setParams(params);
    } else {
      localStorage.setItem("theme", "dark");
      params.set("theme", "dark");
      setParams(params);
    }
  };

  const handleSocialPage = (page) => {
    window.open(page, "_blank");
  };

  const handleLanguagedata = async (langCode) => {
    setLoadingTree(true);
    try {
      const timeZone = localStorage.getItem("timezone") || "";
      const promise = await axios.get(
        `${process.env.REACT_APP_API}/menus/${qrCode}/public-tree`,
        {
          headers: {
            localization: langCode,
            timeZone: timeZone.replace(/["]+/g, ""),
          },
        }
      );
      await localStorage.setItem(
        "tree_data",
        JSON.stringify(promise?.data?.data ? promise?.data?.data : [])
      );
      await updateTreeData(promise?.data?.data || []);

      handleLanguage(langCode);
      itemsRefetch();
    } catch (error) {
      // Handle error
    } finally {
      setLoadingTree(false);
    }
  };

  const handleSendNotification = async (title, body) => {
    setLoading(true);
    try {
      const sendNotificationRes = await axios.post(
        `${process.env.REACT_APP_API}/general-notification`,
        {
          venue_id: detailsData?.venue_id,
          title: title || "",
          message: body || "",
          table: params.get("t") || "",
        }
      );

      const sendNotificationFirebase = await sendNotificationFirebaseRes(
        detailsData,
        title || "",
        body || "",
        "notifications"
      );

      if (
        sendNotificationRes?.data?.success &&
        sendNotificationFirebase?.data?.success
      ) {
        setLoading(false);
        toast.success(
          <div className="alignByLang">
            {t("Your notification sent successfully")}
          </div>
        );
      } else {
        setLoading(false);
        toast.error(
          <div className="alignByLang">
            {t("Error while sending the notification.")}
          </div>
        );
      }
    } catch (error) {
      setLoading(false);
      toast.error(
        <div className="alignByLang">
          {t("Error while sending the notification.") + " " + error.message}
        </div>
      );
    }
  };

  const list = (anchor) => (
    <Box
      sx={{ width: anchor === "top" || anchor === "bottom" ? "auto" : 350 }}
      role="presentation"
      onKeyDown={toggleDrawer(anchor, false)}
    >
      <div
        className={`mobile-side-bar min-vh-100`}
        style={{
          color: setMobileTextColor(),
          backgroundColor: setMobileCardColor(),
        }}
      >
        <div className="d-flex justify-content-between mobile-side-bar-top-settings p-4 sub-font">
          {/* <img
              src={detailsData?.logo || noImageAvailable}
              alt="logo"
              style={{ border: `4px solid ${setMobileCardColor()} ` }}
              className="mobile-side-bar-logo"
              onError={onImageError}
            /> */}

          <div>
            <img
              src={detailsData?.logo || noImageAvailable}
              alt="logo"
              style={{ border: `4px solid ${setMobileCardColor()} ` }}
              className="mobile-side-bar-logo"
              onError={onImageError}
            />
            {/* Add name and balance from localStorage */}

            {localStorage.getItem("mobileLoginToken") && (
              <div className="mt-2 text-center" style={{ color: setMobileTextColor() }}>
                <div className="sub-font alignByLang text-center">
                  {t("Welcome")} {localStorage.getItem("customer_name")}
                </div>
                <div className="sub-font alignByLang text-center">
                  {t("Your Balance")} : {localStorage.getItem("customer_balance")}
                </div>
              </div>
            )}
          </div>


          <div className="d-flex justify-content-between">
            <div>
              <span
                className="mx-2 pt-0 cursor"
                onClick={toggleDrawer(anchor, false)}
              >
                <CloseOutlined style={{ color: setMobileTextColor() }} />
              </span>
              <span className="mx-2 pt-0 cursor" onClick={handleClickLang}>
                <TranslateOutlined style={{ color: setMobileTextColor() }} />
              </span>
              <Menu
                id="long-menu"
                MenuListProps={{
                  "aria-labelledby": "long-button",
                }}
                anchorEl={anchorlang}
                open={openLang}
                onClose={handleCloseLang}
                onClick={handleCloseLang}
                PaperProps={{
                  style: {
                    maxHeight: 48 * 4.5,
                    width: "25ch",
                    backgroundColor: setMobileBackColor(),
                  },
                }}
              >
                {languagesData?.data?.data?.languages?.map((lang) => (
                  <MenuItem
                    key={lang.code}
                    onClick={() => handleLanguagedata(lang.code)}
                  >
                    <li
                      className="d-flex justify-content-between align-items-center p-1 sub-font"
                      style={{
                        color:
                          language === lang.code
                            ? setMobileButttonBackColor()
                            : setMobileTextColor(),
                      }}
                    >
                      <span style={{ maxWidth: "80%" }}>
                        {` ${lang.label} ( ${lang.label} ) `}
                      </span>
                      <span
                        style={{ maxWidth: "10%" }}
                        className={`${language === lang.code ? "d-block" : "d-none"
                          }`}
                      >
                        <CheckOutlinedIcon />
                      </span>
                    </li>
                  </MenuItem>
                ))}
              </Menu>
            </div>
            <div>
              {localStorage.getItem("theme") !== "costomize" && (
                <span className="ms-2 pt-0 cursor" onClick={hanldeMode}>
                  {mode === "dark" ? (
                    <DarkModeIcon className="mode-icon-dark" />
                  ) : (
                    <LightModeIcon className="mode-icon-light" />
                  )}
                </span>
              )}
            </div>
          </div>
        </div>

        {loadingTree && <Loading backColor={setMobileBackColor()} />}

        <div className="p-24">
          <div
            className="rounded-4 m-top-12 pt-3 pb-3 px-3 alignByLang"
            style={{
              backgroundColor: setMobileBackColor(),
              borderColor: setMobileCardBorderColor(),
              borderWidth: 1,
              borderStyle: "solid",
            }}
          >
            {JSON.parse(params.get("t")) && (
              <>
                <Badge
                  onClick={() =>
                    handleSendNotification(
                      isMainMode ? "call waiter" : "",
                      isMainMode
                        ? "please call waiter for this table"
                        : ""
                    )
                  }
                  style={{
                    borderRadius: "8px",
                  }}
                  className={`outofinstock-badge-dish-style font-size-14 sub-font m-1`}
                >
                  {t("Call Waiter")}
                </Badge>

                {detailsData?.notification_buttons_settings
                  ?.notification_1_active && (
                    <Badge
                      onClick={() =>
                        handleSendNotification(
                          detailsData?.notification_buttons_settings
                            ?.notification_1_title,
                          detailsData?.notification_buttons_settings
                            ?.notification_1_body
                        )
                      }
                      style={{
                        borderRadius: "8px",
                      }}
                      className={`outofinstock-badge-dish-style font-size-14 sub-font m-1`}
                    >
                      {t(
                        detailsData?.notification_buttons_settings
                          ?.notification_1_button
                      ) || ""}
                    </Badge>
                  )}

                {detailsData?.notification_buttons_settings
                  ?.notification_2_active && (
                    <Badge
                      onClick={() =>
                        handleSendNotification(
                          detailsData?.notification_buttons_settings
                            ?.notification_2_title,
                          detailsData?.notification_buttons_settings
                            ?.notification_2_body
                        )
                      }
                      style={{
                        borderRadius: "8px",
                      }}
                      className={`outofinstock-badge-dish-style font-size-14 sub-font m-1`}
                    >
                      {t(
                        detailsData?.notification_buttons_settings
                          ?.notification_2_button
                      ) || ""}
                    </Badge>
                  )}
              </>
            )}

            <p className="m-top-12 cursor head-font" onClick={handleHome}>
              {t("Home")}
            </p>

            {localStorage.getItem("mobileLoginToken") &&
              localStorage.getItem("mobileLoginToken")?.length > 0 ? (
              <p className="m-top-12 cursor head-font" onClick={handleProfile}>
                {t("My Profile")}
              </p>
            ) : (
              ""
            )}

            {order_ability && localStorage.getItem("mobileLoginToken") ? (
              <p onClick={handleOrders} className="cursor head-font">
                {t("My orders")}
              </p>
            ) : (
              ""
            )}

            {localStorage.getItem("mobileLoginToken") &&
              localStorage.getItem("mobileLoginToken")?.length > 0 ? (
              <p className="m-top-12 cursor head-font" onClick={handleTransactions}>
                {t("My Transactions")}
              </p>
            ) : (
              ""
            )}

            <p className="m-top-12 cursor head-font" onClick={handleFavorites}>
              {t("Favorites")}
            </p>

            <p onClick={handleFeedBack} className="cursor head-font">
              {t("Your opinion Matters!")}
            </p>

            <p onClick={handlePrivacyPolicy} className="cursor head-font">
              {t("Privacy Policy")}
            </p>

            <p onClick={handleTermsAndConditions} className="cursor head-font">
              {t("Terms and Conditions")}
            </p>

            {localStorage.getItem("mobileLoginToken") &&
              localStorage.getItem("mobileLoginToken")?.length > 0 ? (
              <p onClick={handleLogout} className="cursor head-font">
                {t("Logout")}
              </p>
            ) : (
              ""
            )}
          </div>
        </div>
        <div style={{ borderBottom: "1px solid #aaa" }}></div>
      </div>

      <ul className="position-absolute mb-4 bottom-0 start-0 w-100 d-flex justify-content-center list-unstyled">
        {detailsData?.facebook && (
          <li className="mx-2">
            <img
              onClick={() => handleSocialPage(detailsData?.facebook)}
              src={Facebook}
              alt="Facebook icon"
              className="cursor"
            />
          </li>
        )}
        {detailsData?.instagram && (
          <li className="mx-2">
            <img
              onClick={() => handleSocialPage(detailsData?.instagram)}
              src={Instagram}
              alt="Instagram icon"
              className="cursor"
            />
          </li>
        )}
        {detailsData?.twitter && (
          <li className="mx-2">
            <img
              onClick={() => handleSocialPage(detailsData?.twitter)}
              src={Twitter}
              alt="X icon"
              className="cursor"
            />
          </li>
        )}
        {detailsData?.snapchat && (
          <li className="mx-2">
            <img
              onClick={() => handleSocialPage(detailsData?.snapchat)}
              src={Snapchat}
              alt="Snapchat icon"
              className="cursor"
            />
          </li>
        )}
        {detailsData?.website && (
          <li className="mx-2">
            <img
              onClick={() => handleSocialPage(detailsData?.website)}
              src={Global}
              alt="global icon"
              className="cursor"
            />
          </li>
        )}
      </ul>
    </Box>
  );

  const toggleDrawer = (anchor, open) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }

    setState({ ...state, [anchor]: open });
  };

  const openBar = () => {
    setState({ right: true });
  };

  // Render the sections based on mode
  const renderSections = () => {
    if (isMainMode && mianSectionsData?.tree?.tree) {
      return (
        <ScrollMenu
          variant="quilted"
          cols={mianSectionsData?.tree?.tree.length}
          className="mt-2 mb-2 alignByLang"
        >
          {mianSectionsData?.tree?.tree.map((section, index) => {
            return (
              <label
                key={section.id}
                ref={(el) => (sectionRefs.current[index] = el)}
                onClick={() => handleOnNavClick(index)}
                className="sections-list cursor p-2 mb-3 sub-font"
                style={{
                  color:
                    currentSectionId === index
                      ? setMobileButttonBackColor()
                      : setMobileTextColor(),
                  borderColor:
                    currentSectionId === index
                      ? setMobileButttonBackColor()
                      : setMobileTextColor(),
                }}
              >
                {section.name}
              </label>
            );
          })}
        </ScrollMenu>
      );
    } else if (isSectionMode && mianSectionsData?.sections?.sections) {
      return (
        <ScrollMenu
          variant="quilted"
          cols={mianSectionsData?.sections?.sections.length}
          className="mt-2 mb-2 alignByLang"
        >
          {mianSectionsData?.sections?.sections.map((section) => {
            return (
              <label
                key={section.id}
                onClick={() => handleParentSection(section)}
                className="sections-list cursor p-2 mb-3 sub-font"
                style={{
                  color:
                    currentId == section.id
                      ? setMobileButttonBackColor()
                      : setMobileTextColor(),
                  borderColor:
                    currentId == section.id
                      ? setMobileButttonBackColor()
                      : setMobileTextColor(),
                }}
              >
                {section.name}
              </label>
            );
          })}
        </ScrollMenu>
      );
    }
    return null;
  };

  return (
    !languagesIsLoading &&
    mianSectionsData && (
      <div
        className={`position-relative`}
        style={{ backgroundColor: setMobileBackColor() }}
      >
        <MobileNavbar
          toggleDrawer={toggleDrawer}
          openBar={openBar}
          logo={detailsData?.logo}
          cover={detailsData?.cover}
          desc={detailsData?.description}
          parentId={parentId}
          venueName={detailsData?.venu_name}
          handleParent={handleParent}
          backToMain={backToMain}
          width={width}
          label_name={label_name}
          tableName={qrName}
          tableQr={qrCode}
        />

        <ToastContainer />
        <Backdrop
          open={loading}
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        >
          <CircularProgress color="inherit" />
        </Backdrop>

        {!window.location.pathname.includes("/labels") && (
          <div>
            <div style={{ margin: "auto" }}>
              {(mianSectionsData?.tree?.tree || mianSectionsData?.sections?.sections) && (
                <div
                  className={`${isScrolled
                    ? `top-fixed-sections-scroll`
                    : `top-fixed-sections`
                    } w-100 sub-font alignByLang ${localStorage.getItem("mode") === "dark" ? "dark" : "light"
                    }`}
                  style={{
                    margin: "auto",
                    backgroundColor: setMobileBackColor(),
                    width: width,
                  }}
                >
                  {renderSections()}
                </div>
              )}
            </div>
          </div>
        )}

        <Drawer
          anchor={
            localStorage.getItem("lang") === "ar" ||
              localStorage.getItem("lang") === "fa"
              ? "right"
              : "left"
          }
          open={state["right"]}
          onClose={toggleDrawer("right", false)}
        >
          {list("right")}
        </Drawer>
      </div>
    )
  );
};

export default Top;
